module.exports = __webpack_public_path__ + "assets/img/202112-5.ccb2868b.png";